export function getElementSelector(
  element: HTMLElement | null | undefined
): string {
  if (!element) return "";

  if (element.id) {
    return `#${element.id}`;
  }

  const tag = element.tagName.toLowerCase();
  const parts: Array<string> = [tag];

  if (typeof element.className === "string" && element.className.trim()) {
    const classes = element.className.split(/\s+/).filter(Boolean);
    if (classes.length > 0) {
      parts.push(...classes.map((c) => `.${c}`));
    }
  }

  if (element.parentElement) {
    const parentTag = element.parentElement.tagName.toLowerCase();
    parts.unshift(`${parentTag}>`);

    // eslint-disable-next-line unicorn/prefer-spread
    const children = Array.from(element.parentElement.children);
    const index = children.indexOf(element);

    if (index !== -1) {
      parts.push(`:nth-child(${index + 1})`);
    }
  }

  return parts.join("");
}
